import React, { useRef, useEffect } from 'react';
import { View, Text, StyleSheet, Animated, Easing, Dimensions } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import LogoSvg from '../LogoSvg';
import GradientButton from './GradientButton';

const SubscriptionErrorScreen = ({ onRetry, onReturnToPlans }) => {
    const errorOpacity = useRef(new Animated.Value(0)).current;
    
    const screenWidth = Dimensions.get('window').width;
    const screenHeight = Dimensions.get('window').height;

    useEffect(() => {
        Animated.timing(errorOpacity, {
            toValue: 1,
            duration: 800,
            easing: Easing.out(Easing.cubic),
            useNativeDriver: false,
        }).start();
    }, []);

    const handleRetry = () => {
        if (onRetry) onRetry();
    };

    const handleReturnToPlans = () => {
        if (onReturnToPlans) onReturnToPlans();
    };

    return (
        <View style={[styles.errorOuterContainer, { height: screenHeight }]}>
            <LinearGradient
                colors={['#FF4F4F', '#740011']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
                style={styles.errorGradientBackground}
            >
                <View style={[styles.errorContainer, { width: screenWidth, height: screenHeight }]}>
                    <Animated.View style={[styles.errorContent, { opacity: errorOpacity }]}>
                        <View style={styles.errorHeader}>
                            <View style={styles.errorTitleContainer}>
                                <View style={[styles.logoContainer, { transform: [{ rotate: '103deg' }] }]}>
                                    <LogoSvg 
                                        width={32} 
                                        height={32} 
                                        color="rgba(255, 255, 255, 0.80)" 
                                        spin={false}
                                    />
                                </View>
                                <Text style={styles.errorTitle}>Error</Text>
                                <View style={[styles.logoContainer, { transform: [{ rotate: '-150deg' }] }]}>
                                    <LogoSvg 
                                        width={32} 
                                        height={32} 
                                        color="rgba(255, 255, 255, 0.80)" 
                                        spin={false}
                                    />
                                </View>
                            </View>
                        </View>
                        
                        <View style={styles.errorSubtitleContainer}>
                            <Text style={styles.errorSubtitle}>
                                There was a Problem Processing your Subscription
                            </Text>
                        </View>
                        
                        <View style={styles.errorActions}>
                            <GradientButton
                                text="Return to Plans"
                                onPress={handleReturnToPlans}
                                style={styles.errorButton}
                                textStyle={styles.errorButtonText}
                                gradientColors={["#D2D2D2", "#D2D2D2"]}
                            />
                            <GradientButton
                                text="Try Again"
                                onPress={handleRetry}
                                style={styles.errorButton}
                                textStyle={styles.errorButtonText}
                                gradientColors={["#D2D2D2", "#D2D2D2"]}
                            />
                        </View>
                    </Animated.View>
                </View>
            </LinearGradient>
        </View>
    );
};

const styles = StyleSheet.create({
    errorOuterContainer: {
        flex: 1,
        overflow: 'hidden',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    errorGradientBackground: {
        flex: 1,
        width: '100%',
    },
    errorContainer: {
        flex: 1,
        paddingLeft: 48,
        paddingRight: 48,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        overflow: 'hidden',
        borderWidth: 2,
        borderColor: 'black',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
    },
    errorContent: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
    },
    errorHeader: {
        alignSelf: 'stretch',
        paddingTop: 16,
        paddingBottom: 16,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 303,
    },
    errorTitleContainer: {
        height: 32,
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 10,
        flexDirection: 'row',
    },
    errorTitle: {
        fontSize: 40,
        fontFamily: 'ClimateCrisis',
        fontWeight: '400',
        textTransform: 'uppercase',
        lineHeight: 40,
        color: 'rgba(255, 255, 255, 0.80)',
    },
    errorSubtitleContainer: {
        alignSelf: 'stretch',
        paddingTop: 16,
        paddingBottom: 16,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 303,
    },
    errorSubtitle: {
        fontSize: 32,
        fontFamily: 'Slate',
        fontWeight: '500',
        textTransform: 'uppercase',
        lineHeight: 32,
        color: 'rgba(255, 255, 255, 0.80)',
        textAlign: 'center',
    },
    errorActions: {
        width: 319,
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20,
        flexDirection: 'row',
    },
    errorButton: {
        backgroundColor: 'rgba(116, 154, 119, 0.20)',
        borderColor: 'rgba(116, 154, 119, 0.30)',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.10,
        shadowRadius: 4,
        elevation: 4,
    },
    errorButtonText: {
        color: '#D2D2D2',
        fontSize: 15,
        fontFamily: 'Slate',
        fontWeight: '500',
        lineHeight: 20,
    },
    logoContainer: {
        width: 32,
        height: 32,
        position: 'relative',
        overflow: 'visible',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default SubscriptionErrorScreen;
